import { ClinicProduct, ListResult, SupplierPublicBrand } from '../types';
import { db, findSupplierBySlug } from './db';
import { delay } from './delay';
import { ERR_NOT_FOUND } from './errors';

const isPurchasable = (p: ClinicProduct): boolean => {
  if (p.productType === 'VIRTUAL') {
    const vc = p.virtualConfig;
    if (vc?.autoDelistAt && Date.parse(vc.autoDelistAt) <= Date.now()) return false;
    if (vc && vc.capacity !== null && vc.capacity - vc.reservedSlots - vc.soldSlots <= 0) return false;
    return true;
  }
  return p.stockStatus !== 'OUT_OF_STOCK';
};

export const supplierBrandMock = {
  list: async (
    query: { keyword?: string; skip?: number; take?: number } = {},
  ): Promise<ListResult<SupplierPublicBrand>> => {
    await delay();
    const skip = query.skip ?? 0;
    const take = query.take ?? 0;
    const kw = query.keyword?.trim().toLowerCase();
    const filtered = db.suppliers.filter((s) =>
      kw ? s.publicBrandName.toLowerCase().includes(kw) : true,
    );
    const items = take === 0 ? filtered.slice(skip) : filtered.slice(skip, skip + take);
    return { items: items.map((s) => ({ ...s })), skip, take, total: filtered.length };
  },

  detail: async (slug: string): Promise<SupplierPublicBrand> => {
    await delay();
    const s = findSupplierBySlug(slug);
    if (!s) throw ERR_NOT_FOUND('Supplier');
    return { ...s };
  },

  products: async (
    slug: string,
    query: { skip?: number; take?: number } = {},
  ): Promise<ListResult<ClinicProduct>> => {
    await delay();
    const supplier = findSupplierBySlug(slug);
    if (!supplier) throw ERR_NOT_FOUND('Supplier');
    const skip = query.skip ?? 0;
    const take = query.take ?? 0;
    const filtered = db.products.filter(
      (p) => p.supplier?.supplierId === supplier.supplierId && isPurchasable(p),
    );
    const items = take === 0 ? filtered.slice(skip) : filtered.slice(skip, skip + take);
    return { items, skip, take, total: filtered.length };
  },
};
